import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  link: {
    color: 'red',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
  },
}));
